import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { DRAWER_CONTENTS, PARTICIPANTS_TABS_CONSTANTS, ROLE } from '../../../const';

import * as classroomActions from '../../../actions/classroom/classroomActions';
import * as classroomGroupActions from '../../../actions/classroom/classroomGroupActions';

import * as drawerActions from '../../../actions/drawerActions';

import StudentList from './StudentList';
import CustomIcon from '../../common/CustomIcon';

export class ParticipantsWrapper extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      open: false,
      selectMenuOption: {
        key: PARTICIPANTS_TABS_CONSTANTS.STUDENTS.key,
        label: PARTICIPANTS_TABS_CONSTANTS.STUDENTS.label
      }
    };
  }

  componentDidMount() {
    const { classroomActions, idClassroom } = this.props;

    classroomActions.getClassroomGroups(idClassroom);
    classroomActions.getClassroomParticipants(idClassroom);
  }

  getParticipants = tab => (
    <Fragment key={tab.key}>
      <StudentList
        isTeacherView={this.isTeacherTab()}
        classes={tab.key === PARTICIPANTS_TABS_CONSTANTS.TEACHERS.key ? 'teachers-list' : ''}
        onSelectorChange={this.onSelectorChange}
        onToggleMenu={this.onToggleMenu}
        onCloseMenu={this.onCloseMenu}
        selectMenuOption={this.state.selectMenuOption}
        open={this.state.open}
      />
      {this.renderNewUserButton(tab)}
    </Fragment>
  );

  isTeacherTab = tab => this.state.selectMenuOption.key === PARTICIPANTS_TABS_CONSTANTS.TEACHERS.key;

  openNewParticipantDrawer = () => {
    const { drawerActions } = this.props;
    drawerActions.openDrawerAndSetContent(DRAWER_CONTENTS.ADD_NEW_USER);
  };

  onSelectorChange = option => {
    this.setState({
      open: false,
      selectMenuOption: {
        key: option.value,
        label: option.name
      }
    });
    this.props.classroomActions.setActiveTab(option.value);
  };

  onToggleMenu = () => {
    this.setState({ open: !this.state.open });
  };

  onCloseMenu = () => {
    this.setState({ open: false });
  };

  renderNewUserButton(tab) {
    const { role, enableEnrollment } = this.props;
    if (role === ROLE.INSTRUCTOR && enableEnrollment) {
      return (
        <button
          className={`fab-button ${tab.key === PARTICIPANTS_TABS_CONSTANTS.STUDENTS.key ? 'participants-sticky' : ''}`}
          onClick={this.openNewParticipantDrawer}
        >
          <CustomIcon name="plus-button" size={24} />
        </button>
      );
    }
  }

  render() {
    const { groupId } = this.props;

    return (
      <div style={{ float: 'left', width: '100%', height: '100%', overflow: 'hidden' }}>
        {groupId === 0 ? (
          this.getParticipants(PARTICIPANTS_TABS_CONSTANTS[this.state.selectMenuOption.key])
        ) : (
          <Fragment>
            <StudentList
              classes={'group'}
              onSelectorChange={this.onSelectorChange}
              onToggleMenu={this.onToggleMenu}
              onCloseMenu={this.onCloseMenu}
            />
          </Fragment>
        )}
      </div>
    );
  }
}

ParticipantsWrapper.propTypes = {
  activeClassroomTab: PropTypes.string,
  classroom: PropTypes.object,
  params: PropTypes.object,
  classroomActions: PropTypes.object,
  classroomGroupActions: PropTypes.object,
  role: PropTypes.string,
  drawerActions: PropTypes.object,
  groupId: PropTypes.any,
  enableEnrollment: PropTypes.bool
};

const mapStateToProps = state => ({
  classroom: state.classrooms.selectedClassroom.classroom,
  role: state.classrooms.selectedClassroom.classroom.role,
  activeClassroomTab: state.classrooms.selectedClassroom.activeClassroomTab,
  idClassroom: state.router.params.idClassroom,
  enableEnrollment: state.account.configuration.enableEnrollment,
  groupId: state.selectedGroup.group.id
});

const mapDispatchToProps = dispatch => ({
  classroomActions: bindActionCreators(classroomActions, dispatch),
  classroomGroupActions: bindActionCreators(classroomGroupActions, dispatch),
  drawerActions: bindActionCreators(drawerActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(ParticipantsWrapper);
